/*
 * Nische product page behaviour.
 *
 * Buy now is Shopify's dynamic checkout button (checks out only this product,
 * cart untouched). Shopify renders the button and its "Buy it now" text
 * itself, after page load, so the merchant's "Buy now label" setting is
 * applied here once the button exists — and re-applied if Shopify redraws it.
 */
(function () {
  'use strict';

  if (window.NischeBuyNowLabel) return;
  window.NischeBuyNowLabel = true;

  var SELECTOR = '.shopify-payment-button__button--unbranded';

  function apply(wrap) {
    var label = wrap.getAttribute('data-nis-buy-now-label');
    if (!label) return;
    var buttons = wrap.querySelectorAll(SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].textContent !== label) buttons[i].textContent = label;
    }
  }

  function watch(wrap) {
    if (wrap.__nisLabelWatched) return;
    wrap.__nisLabelWatched = true;
    apply(wrap);
    new MutationObserver(function () {
      apply(wrap);
    }).observe(wrap, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    var wraps = document.querySelectorAll('[data-nis-buy-now-label]');
    for (var i = 0; i < wraps.length; i++) watch(wraps[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/*
 * Media modal on phones: swipe between images, with the image following the
 * finger.
 *
 * Below 750px Dawn's modal shows only the tapped image (every other media
 * child is display:none) and offers no way to reach the rest - the shopper
 * has to close it and tap the next thumbnail. This makes a horizontal drag
 * on the open modal slide the current image with the finger while the
 * neighbour slides in beside it; on release it settles forward if the drag
 * went far or fast enough, otherwise springs back. At either end it rubber-
 * bands. A one-line hint under the image says "swipe left" while there is
 * more and "swipe right" on the last one. Desktop shows all media stacked and
 * is untouched.
 *
 * Cost: transform-only (composited, no layout), listeners are passive
 * (touch-action: pan-y in the CSS keeps vertical scroll native), and the two
 * neighbouring images are simply switched from lazy to eager so they are
 * already there when they slide in. Nothing runs until the modal is open.
 *
 * Hooks product-modal.js's showActiveMedia rather than editing that stock
 * file, and only for the Nische fork of the modal (.nische-media-modal).
 */
(function () {
  'use strict';

  if (window.NischeMediaModalSwipe) return;
  window.NischeMediaModalSwipe = true;

  var phone = window.matchMedia('(max-width: 749px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var COMMIT_PX = 60;      /* drag distance that commits a slide */
  var COMMIT_VEL = 0.45;   /* px per ms - a quick flick commits too */
  var SETTLE_MS = 260;

  function content(modal) { return modal.querySelector('[role="document"]'); }
  function mediaOf(modal) {
    var c = content(modal);
    return c ? Array.prototype.slice.call(c.querySelectorAll(':scope > [data-media-id]')) : [];
  }
  function activeOf(modal) { return content(modal).querySelector(':scope > .active'); }

  function preload(el) {
    if (!el) return;
    if (el.nodeName === 'IMG' && el.loading === 'lazy') el.loading = 'eager';
  }
  function warmNeighbours(modal) {
    var list = mediaOf(modal), i = list.indexOf(activeOf(modal));
    preload(list[i - 1]);
    preload(list[i + 1]);
  }

  function updateHint(modal) {
    var hint = modal.querySelector('.nische-media-modal__hint');
    if (!hint) return;
    var list = mediaOf(modal), i = list.indexOf(activeOf(modal));
    if (list.length < 2 || i < 0 || !phone.matches) { hint.hidden = true; return; }
    var last = i === list.length - 1;
    hint.textContent = last ? hint.getAttribute('data-hint-back') : hint.getAttribute('data-hint-next');
    hint.classList.toggle('nische-media-modal__hint--back', last);
    hint.hidden = false;
  }

  function setX(el, x) { el.style.transform = 'translate3d(' + x + 'px, 0, 0)'; }
  function setPeekX(el, x) { el.style.transform = 'translate3d(' + x + 'px, -50%, 0)'; }
  function clear(el) { if (el) { el.style.transform = ''; el.style.transition = ''; el.classList.remove('is-peek'); } }

  function commit(modal, from, to) {
    if (modal.__nisZoomReset) modal.__nisZoomReset();
    from.classList.remove('active');
    to.classList.add('active');
    clear(from); clear(to);
    if (to.nodeName === 'DEFERRED-MEDIA' && typeof to.loadContent === 'function') to.loadContent();
    content(modal).scrollTop = 0;
    updateHint(modal);
    warmNeighbours(modal);
  }

  function bind(modal) {
    if (modal.__nisSwipe) return;
    modal.__nisSwipe = true;
    var c = content(modal);
    if (!c) return;

    var x0 = 0, y0 = 0, t0 = 0, dx = 0, axis = null, from = null, to = null, dir = 0, busy = false;

    function neighbour(d) {
      var list = mediaOf(modal), i = list.indexOf(from);
      return list[i + d] || null;
    }
    function width() { return c.clientWidth; }

    function onStart(e) {
      if (busy || !phone.matches || e.touches.length !== 1) return;
      if (modal.__nisZoomed && modal.__nisZoomed()) return;
      from = activeOf(modal);
      if (!from) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = e.timeStamp;
      dx = 0; axis = null; to = null; dir = 0;
      from.style.transition = 'none';
    }

    function onMove(e) {
      if (!from || busy || e.touches.length !== 1) return;
      if (modal.__nisZoomed && modal.__nisZoomed()) { from = null; return; }
      var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
      if (!axis) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
      }
      if (axis !== 'x') return;
      dx = mx;
      var d = dx < 0 ? 1 : -1;
      if (d !== dir) {
        /* Direction changed (or first move): swap which neighbour peeks. */
        if (to) clear(to);
        dir = d;
        to = neighbour(dir);
        if (to) {
          to.classList.add('is-peek');
          to.style.transition = 'none';
        }
      }
      if (to) {
        setX(from, dx);
        setPeekX(to, dx + dir * width());
      } else {
        /* Nothing that way: rubber-band. */
        setX(from, dx * 0.3);
      }
    }

    function onEnd(e) {
      if (!from) return;
      var f = from, t = to, d = dir, moved = dx;
      var dt = Math.max(e.timeStamp - t0, 1);
      var vel = Math.abs(moved) / dt;
      var go = !!t && axis === 'x' && (Math.abs(moved) > COMMIT_PX || vel > COMMIT_VEL);
      from = null; to = null; axis = null; dx = 0; dir = 0;

      if (!moved) { f.style.transition = ''; if (t) clear(t); return; }
      if (reduced.matches) {
        if (go) commit(modal, f, t); else { clear(f); if (t) clear(t); }
        return;
      }

      busy = true;
      var ease = 'transform ' + SETTLE_MS + 'ms cubic-bezier(0.22, 0.61, 0.36, 1)';
      f.style.transition = ease;
      if (t) t.style.transition = ease;
      /* Force the "none" transition to flush before animating. */
      void f.offsetWidth;
      if (go) {
        setX(f, -d * width());
        setPeekX(t, 0);
      } else {
        setX(f, 0);
        if (t) setPeekX(t, d * width());
      }
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        busy = false;
        if (go) commit(modal, f, t); else { clear(f); if (t) clear(t); }
      }
      f.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, SETTLE_MS + 80);
    }

    c.addEventListener('touchstart', onStart, { passive: true });
    c.addEventListener('touchmove', onMove, { passive: true });
    c.addEventListener('touchend', onEnd, { passive: true });
    c.addEventListener('touchcancel', onEnd, { passive: true });
  }

  /*
   * Pinch-zoom inside the phone modal.
   *
   * Two fingers scale the active image between 1x and data-max-zoom (a
   * section setting, default 3x) around the point between the fingers. Once
   * zoomed, one finger pans it and the swipe-between-images above stands down
   * (it checks __nisZoomed); letting go below 1.02x snaps back to 1x, at which
   * point swiping works again. Double-tap toggles between 1x and a fixed
   * mid zoom around the tapped point. Zoom is reset whenever the image
   * changes (commit above) or the modal opens/closes.
   *
   * The pan is clamped so the image can never be dragged off the screen:
   * while it is smaller than the box on an axis it stays inside the box,
   * once larger it must keep the box covered.
   *
   * touch-action on the box is pan-y for the swipe; while zoomed the CSS
   * switches it to none and the script cancels the touchmove default itself,
   * which is why these listeners are NOT passive. All maths runs off the
   * element's current bounding rect, so it never depends on the layout.
   */
  function bindZoom(modal) {
    if (modal.__nisZoom) return;
    modal.__nisZoom = true;
    var c = content(modal);
    if (!c) return;
    /* Bounds and clipping are the full-screen dialog, not the image's own
       box, so a zoomed image can fill the phone screen. */
    var box = modal.querySelector('.product-media-modal__dialog') || c;

    var MAX = parseFloat(modal.getAttribute('data-max-zoom')) || 3;
    if (MAX < 1.5) MAX = 1.5;
    var MID = Math.min(2.5, MAX);
    var z = { el: null, s: 1, x: 0, y: 0 };
    var g = null;
    var lastTap = 0, lastX = 0, lastY = 0;

    function apply() {
      if (!z.el) return;
      if (z.s > 1) {
        z.el.style.transition = 'none';
        z.el.style.transform = 'translate3d(' + z.x + 'px, ' + z.y + 'px, 0) scale(' + z.s + ')';
        z.el.classList.add('nis-zoom-el');
        c.classList.add('nis-zoomed');
        box.classList.add('nis-zoomed');
      } else {
        z.el.style.transform = '';
        z.el.style.transition = '';
        z.el.classList.remove('nis-zoom-el');
        c.classList.remove('nis-zoomed');
        box.classList.remove('nis-zoomed');
      }
    }
    function reset() {
      z.s = 1; z.x = 0; z.y = 0;
      apply();
      z.el = null;
      g = null;
    }
    /* Base (unscaled, untranslated) centre of the element, relative to the box. */
    function base() {
      var r = z.el.getBoundingClientRect(), b = box.getBoundingClientRect();
      return {
        cx: r.left + r.width / 2 - b.left - z.x,
        cy: r.top + r.height / 2 - b.top - z.y,
        w: r.width / z.s,
        h: r.height / z.s,
        bw: b.width,
        bh: b.height
      };
    }
    function clampAxis(t, centre, size, box) {
      var half = size / 2, lo, hi;
      if (size <= box) { lo = -(centre - half); hi = box - (centre + half); }
      else { lo = box - (centre + half); hi = -(centre - half); }
      return Math.min(hi, Math.max(lo, t));
    }
    function clamp(bs) {
      z.x = clampAxis(z.x, bs.cx, bs.w * z.s, bs.bw);
      z.y = clampAxis(z.y, bs.cy, bs.h * z.s, bs.bh);
    }
    function dist(t) {
      var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
      return Math.sqrt(dx * dx + dy * dy) || 1;
    }
    function mid(t) {
      var b = box.getBoundingClientRect();
      return { x: (t[0].clientX + t[1].clientX) / 2 - b.left, y: (t[0].clientY + t[1].clientY) / 2 - b.top };
    }
    function zoomTo(s, px, py) {
      /* Keep the point (px,py) - box coords - fixed on screen while scaling. */
      var bs = base();
      var p = { x: (px - bs.cx - z.x) / z.s, y: (py - bs.cy - z.y) / z.s };
      z.s = Math.min(MAX, Math.max(1, s));
      z.x = px - bs.cx - p.x * z.s;
      z.y = py - bs.cy - p.y * z.s;
      clamp(bs);
      apply();
    }

    function onStart(e) {
      if (!phone.matches) return;
      var el = activeOf(modal);
      if (!el || el.nodeName !== 'IMG') return;
      if (z.el && z.el !== el) reset();
      z.el = el;
      if (e.touches.length === 2) {
        e.preventDefault();
        g = { type: 'pinch', d0: dist(e.touches), s0: z.s, moved: true };
      } else if (e.touches.length === 1 && z.s > 1) {
        g = { type: 'pan', x0: e.touches[0].clientX, y0: e.touches[0].clientY, tx: z.x, ty: z.y, moved: false };
      } else if (e.touches.length === 1) {
        g = { type: 'tap', x0: e.touches[0].clientX, y0: e.touches[0].clientY, moved: false };
      }
    }
    function onMove(e) {
      if (!g || !z.el) return;
      if (g.type === 'pinch' && e.touches.length === 2) {
        e.preventDefault();
        var m = mid(e.touches);
        zoomTo(g.s0 * dist(e.touches) / g.d0, m.x, m.y);
      } else if (g.type === 'pan' && e.touches.length === 1) {
        e.preventDefault();
        var dx = e.touches[0].clientX - g.x0, dy = e.touches[0].clientY - g.y0;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) g.moved = true;
        z.x = g.tx + dx; z.y = g.ty + dy;
        clamp(base());
        apply();
      } else if (g.type === 'tap') {
        var mx = e.touches[0].clientX - g.x0, my = e.touches[0].clientY - g.y0;
        if (Math.abs(mx) > 10 || Math.abs(my) > 10) g.moved = true;
      }
    }
    function onEnd(e) {
      if (!g || !z.el) return;
      var was = g; g = null;
      if (e.touches.length > 0) {
        /* One finger lifted from a pinch: carry on as a pan. */
        if (z.s > 1 && e.touches.length === 1) {
          g = { type: 'pan', x0: e.touches[0].clientX, y0: e.touches[0].clientY, tx: z.x, ty: z.y, moved: true };
        }
        return;
      }
      if (z.s <= 1.02) { reset(); }
      if (was.type === 'tap' || (was.type === 'pan' && !was.moved)) {
        var now = e.timeStamp, x = was.x0, y = was.y0;
        var dbl = now - lastTap < 320 && Math.abs(x - lastX) < 30 && Math.abs(y - lastY) < 30;
        lastTap = now; lastX = x; lastY = y;
        if (dbl) {
          lastTap = 0;
          if (z.s > 1) { reset(); }
          else {
            var b = box.getBoundingClientRect();
            z.el = activeOf(modal);
            if (z.el) zoomTo(MID, x - b.left, y - b.top);
          }
        }
      }
    }

    c.addEventListener('touchstart', onStart, { passive: false });
    c.addEventListener('touchmove', onMove, { passive: false });
    c.addEventListener('touchend', onEnd, { passive: false });
    c.addEventListener('touchcancel', onEnd, { passive: false });

    modal.__nisZoomed = function () { return z.s > 1; };
    modal.__nisZoomReset = function () { if (z.el) reset(); };
  }

  customElements.whenDefined('product-modal').then(function () {
    var proto = customElements.get('product-modal').prototype;
    var originalHide = proto.hide;
    proto.hide = function () {
      if (this.__nisZoomReset) this.__nisZoomReset();
      return originalHide.apply(this, arguments);
    };
    var original = proto.showActiveMedia;
    proto.showActiveMedia = function () {
      original.apply(this, arguments);
      if (!this.classList.contains('nische-media-modal')) return;
      /* A new open may land on a media that was mid-clean-up. */
      if (this.__nisZoomReset) this.__nisZoomReset();
      mediaOf(this).forEach(clear);
      bind(this);
      bindZoom(this);
      updateHint(this);
      if (phone.matches) warmNeighbours(this);
    };
  });
})();
